import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/store";
import {selectNotifications} from "../../../store/notificationCenter/notificationCenter.selectors";
import {tap} from "rxjs/operators";
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {Serializer} from "../../../interfaces/serializer";
import {Site} from "../../../interfaces/site";
import {switchMap} from "rxjs";

@Injectable()
export class NotificationSectionStore extends ComponentStore<any> {
  public readonly notifications$: any = this.select(state => state.notifications);

  public readonly onInit = this.effect((site$: any): any => site$.pipe(
    switchMap((site: Serializer<Site>) => this._store.select(selectNotifications).pipe(
      tap((notifications: NotificationComponentObject[]): void => {
        this.patchState({
          notifications: notifications
            .filter((notification: NotificationComponentObject) => notification.payload.relationships.data_set.data.id == site.id)
        });
      })
    ))
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      notifications: []
    });
  }

}
